import http from "../utils/http";
import axios from "axios";

export function getAllCardsAndEquips(
  params = {
    equip_type: "",
    card_level: "",
    equip_level: "",
    lang: "cn",
  }
) {
  return http({
    url: "game/storeInfo",
    params,
    method: "get",
  });
}

export function getCardEarnings(cardID) {
  //获取累计收益
  return http({
    url: "game/getCardEarnings",
    params: {
      nft_id: cardID,
    },
    method: "get",
  });
}

export function getLastNotice(params) {
  return http({
    url: "game/lastNews",
    method: "get",
    params,
  });
}

export function getNameByTokenId(params) {
  return http({
    url: "game/getNameByTokenId",
    params,

    method: "get",
  });
}

export async function getHistory(params) {
  const res = await  http({
    url: "game/getHistory",
    params,
  });
  
    return res

}

export function getEarnReward(account) {
  return http({
    url: "game/getEarningsTotal",
    params: {
      addr: account,
    },
  });
}

export function getLotterySum(account) {
  return http({
    url: "game/getLotteryTotal",
    params: {
      addr: account,
    },
  });
}

//获取领奖记录
export function getLotteryRecords(account) {
  return http({
    url: "game/getLotteryRecords",
    params: {
      addr: account,
    },
  }).then((res) => {
    return res.list;
  });
}

export function getLevel(account) {
  return http({
    url: "game/getClassLevel",
    params: {
      addr: account,
    },
    method: "GET",
  });
}

export function getInviternfo(account) {
  return http({
    url: "game/getSubUser",
    params: {
      addr: account,
    },
    method: "GET",
    success: (res) => {
      if (res.data.code === 0) {
        return res;
      }
    },
  });
}

export function getRBTransfer(account, type) {
  return http({
    url: "game/getRBTransfer",
    method: "GET",
    params: {
      addr: account,
      trans_type: type,
    },
  });
}

export function getRewards(account, page) {
  return http({
    url: "/game/reward",
    method: "get",
    params: {
      addr: account,
      page,
      page_size: 10,
    },
  });
}

export function getTeamEarning(account, page) {
  return http({
    url: "/game/teamEarning",
    method: "get",
    params: {
      addr: account,
      page,
      page_size: 10,
    },
  });
}

export function getRTPrice() {
  return http({
    url: "/game/getPrice",
    method: "get",
  });
}

export function getGasoracle() {
  return axios({
    method:"get",
    url: "https://api.polygonscan.com/api?module=gastracker&action=gasoracle&apikey=XY4S7YKDR1VTIV732VCXMWSGVGISI52YZS",
  });
}


export async function getIncome(params) {
  return http({
    url: "game/getIncome",
    params,
  }).then((res) => {
    console.log(res)
    return res.data.list;
  });
}


export async function getWithdraw(params) {
  return http({
    url: "game/getWithdraw",
    params,
  }).then((res) => {
    return res.data.list;
  
  });
 
}


export async function withdraw (data) {
  return http({
    method:'post',
    url: "game/withdraw",
    data,
  })
}

export async function getRevenue(params) {
  return http({
    url: "game/revenue",
    params,
  })
}

export async function getUserShoesInfo(params){
  return http({
    url:'game/getUserShoesInfo',
    params
  })
}


export async function getShoesState(params){
  return http({
    url:'game/getShoesState',
    params
  })
}
export async function getShoesInfo(params) {
  const res = await http({
    url:'game/getShoesInfo',
    params
  })
  return res.data

}


export async function shoesHandle(data) {
  return http({
    method:'post',
    url:'game/shoesHandle',
    data
  })
}

export  function userBind(data) {
  return  http({
    method:'post',
    url:'game/userBind',
    data
  })
}

export function getUserInfo (params) {
  return  http({
    method:'get',
    url:'game/userInfo',
    params
  })
}